import paymentCategoryLogoDictionary from "../../paymentCategoryLogoDictionary";

export const linkStatusTableSchema = [
  { name: "Payment_Status", label: "Statuses", sort: false },
  { name: "count", label: "Count" },

  { name: "value", label: "Value" },
  { name: "percentage", label: "%" },
];

export const avgCompletionTimeTableSchema = [
  {
    name: "paymentCategoryLocale",
    label: "Payment Category",
    align: "left",
    showLogo: "false",
    logoKey: "paymentCategory",
    logoDictKey: "logoColored",
    logoDictionary: paymentCategoryLogoDictionary,
    chipColor: "#F2F1FF",
    sort: false,
  },
  {
    name: "averageUserDurationLocale",
    label: "Average Completion Time",
    align: "right",
    sort: true,
  },
];
